<template>
    <solid-box title="竞拍项目">
        <table-info :columns="columns" :table-data="tableData" />
    </solid-box>
</template>

<script>
import TableInfo from '@/components/TableInfo'
import * as fcScreenAPI from '@/api/fc-screen'
import SolidBox from '@/components/SolidBox'

/**
 * 竞拍项目
 */
export default {
    components: {
        TableInfo,
        SolidBox
    },
    data() {
        return {
            columns: [
                { title: '项目名称', field: 'projectName', width: '36%' },
                { title: '面积/数量', field: 'acreage', width: '16%' },
                { title: '起拍价', field: 'price', type: 'emphasize' },
                { title: '挂牌时间', field: 'time' }
            ],
            tableData: []
        }
    },
    mounted() {
        this.getProjectList()
    },
    methods: {
        async getProjectList() {
            const params = {
                model: 'more',
                page: 1,
                rows: 50
            }
            const response = await fcScreenAPI.getAuctionProjectList(params)
            if (response && response.data) {
                this.tableData = response.data || []
                for (let i = 0; i < this.tableData.length; i++) {
                    this.tableData[i].projectName = this.tableData[
                        i
                    ].standardName
                    this.tableData[i].acreage = this.tableData[i].area
                    // priceUnit=1 元(总价)
                    // priceUnit=2 && auctionUnit=1 元/亩
                    // priceUnit=2 && auctionUnit=2 元/亩/年
                    // priceUnit=2 && auctionUnit=3 元/平方米
                    // priceUnit=2 && auctionUnit=4 元/平方米/年
                    let unit = '元(总价)'
                    if (this.tableData[i].priceUnit === 1) {
                        unit = '元(总价)'
                    } else {
                        if (this.tableData[i].auctionUnit === 1) {
                            unit = '元/亩'
                        } else if (this.tableData[i].auctionUnit === 2) {
                            unit = '元/亩/年'
                        } else if (this.tableData[i].auctionUnit === 3) {
                            unit = '元/平方米'
                        } else {
                            unit = '元/平方米/年'
                        }
                    }
                    this.tableData[i].price =
                        this.tableData[i].reservePrice + (unit || '')
                    this.tableData[i].time = this.tableData[i].auctionStartTime
                }
            }
        }
    }
}
</script>

<style scoped>
/deep/ .el-tabs {
    position: absolute;
    right: 24px;
    top: 7px;
}

/deep/ .el-tabs__nav-wrap::after {
    background: unset;
}

/deep/ .el-tabs__header {
    margin-bottom: 10px;
}

/deep/ .el-tabs__item {
    font-size: 14px;
    color: #67f0ff;
    padding: 0 4px;
    height: 35px;
}

/deep/ .el-tabs__item.is-active {
    color: #67f0ff;
}

/deep/ .el-tabs__content {
    color: #67f0ff;
}

/deep/ .el-tabs__nav {
    float: left;
}

/deep/ .el-carousel__container {
    height: 190px;
}
</style>
